import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';

import translations from '../i18n';
import {sdoNs} from '../constants-enumerate';
import {storeInstance} from '@aofl/store/dist/legacy';
/**
 * @summary NotificationBell
 * @extends {i18nMixin(AoflElement)}
 */
@customElement('notification-bell')
class NotificationBell extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of NotificationBell.
   */
  constructor() {
    super();
    this.translations = translations;
  }

  /**
   * @readonly
   */
  static is = 'notification-bell';

  @property({type: Number, mapState: `${sdoNs.USER_JOBS}.$unseenCount`, store: storeInstance})
  count = 0;

  @property({type: Array, mapState: `${sdoNs.USER_JOBS}.$notificationBellJobs`, store: storeInstance})
  jobs = [];

  @property({type: Array, mapState: `${sdoNs.SESSION}.locale`, store: storeInstance})
  locale = '';

  dismiss(job) {
    storeInstance.commit({
      namespace: sdoNs.USER_JOBS,
      mutationId: 'setDismissedJob',
      payload: job.id
    });
  }

  setSeenJobs() {
    const ids = [];

    this.jobs.forEach((job) => {
      ids.push(job.id);
    });

    storeInstance.commit({
      namespace: sdoNs.USER_JOBS,
      mutationId: 'setSeenJobs',
      payload: ids
    });
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {
        template,
        styles: [styles]
      }
    });
  }
}

export default NotificationBell;
